import { ComponentType } from 'react';

import Loadable from '@townsquare/loadable';
import { RouteContext } from '@townsquare/router/routing-types';

export const AgentsViewLoadable: ComponentType<RouteContext> & LoadableExport.LoadableComponent =
	Loadable({
		loader: () => import(/* webpackChunkName: "agents-view" */ './AgentsView'),
		loading: () => null,
	});
